@if (svc.pending(); as p) {
  <div class="confirm-overlay" (click)="onCancel()">
    <div class="confirm-card" (click)="$event.stopPropagation()" data-testid="confirm-snackbar">
      @if (p.title) {
        <div class="confirm-title">{{ p.title }}</div>
      }
      <div class="confirm-message">{{ p.message }}</div>
      <div class="confirm-actions">
        <button
          class="confirm-btn confirm-btn-cancel"
          data-testid="confirm-cancel-btn"
          (click)="onCancel()"
        >
          {{ p.cancelLabel || ('common.cancel' | translate) }}
        </button>
        <button
          class="confirm-btn confirm-btn-confirm"
          [class.danger]="p.danger"
          data-testid="confirm-ok-btn"
          (click)="onConfirm()"
        >
          {{ p.confirmLabel || ('common.ok' | translate) }}
        </button>
      </div>
    </div>
  </div>
}
